export default __webpack_public_path__ + "static/media/plus-minus.2bad8f5b.svg";